export const environment = {
  production: false,
  authority: 'https://signin.dev-connect.aveva.com',
  clientId: 'xoGCgTPeUQmOVlYaeHLr23jO3Lix3dS1',
  singleSignOutUrl: 'https://profile.capdev-connect.aveva.com/singlesignout',
  sessionExpiredUrl: 'https://profile.capdev-connect.aveva.com/sessionexpired',
  connect: 'https://capdev-connect.aveva.com',
  appInsightsConnectionString: 'U2FsdGVkX1+BWVjYbotiQB8mMuafpSspyXtKyEZ/Ac2EmVnBmcHyvYFPzYcTRux5BHZe4rBBhFNEoMzOYbEh3Dzu5Cv8bER7oIfXjfLxPr8a/pdbzQBDDzTJ5bYpG1vXb+Tgdr+1tH1iBSpGEZySjXTu0DuyT5U9S5eFPHupyi4/H32SmYx4rl06mTFmUTZDu+caQPuT8mCkHRY0prbYhKc2JrpZ+bwKBM6/dkRT0veYLv83fn4lIa+eSjt08HqSJHUuTMxz3JeuMc3gLjQkmcj+ILbwxsOi2D1QA0BnwjYyz/fZ1fL2upN38My7e8L6dTKRkMdf7k0lp0W4YJtJOA==',
  apis: {
    am: 'https://api.capdev-connect.aveva.com/am',
    registry: 'https://api.capdev-connect.aveva.com/registry',
    uam: 'https://services.capdev-connect.aveva.com/uam/v2',
    scm: 'https://api.capdev-connect.aveva.com/scm',
    logging: 'https://api.capdev-connect.aveva.com/logging',
    assets: 'https://api.capdev-connect.aveva.com/assets',
    connect: 'https://connectapi.tc.capdev-connect.aveva.com',
    cds: 'https://cdsapi.tc.capdev-connect.aveva.com'
  }
};
